import { setLocale } from 'yup';

export const initYupLocale = () =>
  setLocale({
    mixed: {
      required: 'isRequired',
      oneOf: 'isRequired',
    },
    string: {
      email: 'isEmail',
      url: 'isUrl',
    },
    number: {
      positive: 'isPositive',
      integer: 'isInteger',
    },
  });
